import React, { useState, useEffect } from 'react';
import './Navbar.css';

export const Navbar = ({ name, activeSection, onSectionClick }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { id: 'overview', label: 'Overview', icon: 'fas fa-home' },
    { id: 'requirements', label: 'Requirements', icon: 'fas fa-list-check' },
    { id: 'intake', label: 'Intake', icon: 'fas fa-calendar' },
    { id: 'programs', label: 'Programs', icon: 'fas fa-graduation-cap' },
    { id: 'cost', label: 'Cost', icon: 'fas fa-dollar-sign' },
    { id: 'topCities', label: 'Top Cities', icon: 'fas fa-city' },
    { id: 'workOptions', label: 'Work Options', icon: 'fas fa-briefcase' },
    { id: 'questions', label: 'Questions', icon: 'fas fa-question-circle' }
  ];

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollTop = window.scrollY;
//       setIsSticky(scrollTop > 200);
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

  const handleNavClick = (sectionId) => {
    onSectionClick(sectionId);
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="country-navbar">
      <div className="container">
        <div className="navbar-content">
          <div className="navbar-brand">
            <h3>Study in {name}</h3>
          </div>
          
          <div className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <ul className="navbar-list">
              {navItems.map((item) => (
                <li key={item.id} className="navbar-item">
                  <button
                    className={`navbar-link ${activeSection === item.id ? 'active' : ''}`}
                    onClick={() => handleNavClick(item.id)}
                  >
                    <i className={item.icon}></i>
                    <span>{item.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'active' : ''}`}></span>
          </button>
        </div>
      </div>
    </nav>
  );
};
